import { FC } from "react";


interface LayoutBrancoProps {
    title?: string;
    children: React.ReactNode;
}

const LayoutBranco: FC<LayoutBrancoProps> = ({ children }) => {
    return (
        <>
            <main>
                {children}
            </main>
        </>
    )
}

export default LayoutBranco

